module.exports = __webpack_public_path__ + "static/media/iiw_heuschrecken_rundweg_donauinsel.3336c86c.pdf";